const scaPartnersData = [
  {
    id: 1,
    state: "Andhra Pradesh",
    name: "Andhra Pradesh State Minorities Financial Corporation",
    address:
      "Door No.39-3-1, 3rd Floor, Above Anjaneya Jewelers Complex, Venkateswarapuram, Mosque Street, Labbipet, Vijayawada-520 010 Andhra Pradesh",
    contact: "+91-866-2498576",
  },
  {
    id: 2,
    state: "Assam",
    name: "Assam Minorities Development & Finance Corporation",
    address: "R.G.B. Road, Ganesh Guri, Dispur, GUWAHATI - 6 ASSAM",
    contact: "+91-361-2595480, 2207373",
  },
  {
    id: 3,
    state: "Arunachal Pradesh",
    name: "The Arunachal Pradesh State Co-operative Apex Bank Ltd.",
    address: "D Sector Naharlagun Papum Pare District Arunanchal Pradesh-791110",
    contact: "+91-360-2245631,2244356",
  },
  {
    id: 4,
    state: "Goa",
    name: "Goa State Minorities Finance & Development Corporation Ltd.",
    address:
      "Near Directorate of Social Welfare, Opp. Farmacia Salcete, 18th June Road, Panaji, Tiswadi, North-Goa, GOA",
    contact: "",
  },
  {
    id: 5,
    state: "Haryana",
    name: "Haryana Backward Classes & Economically Weaker Sections Kalyan Nigam",
    address: "SCO 813-814, Sector 22-A CHANDIGARH - 160 022",
    contact: "+91-172-2701074",
  },
  {
    id: 6,
    state: "Haryana",
    name: "Mewat Development Agency",
    address: "Housing Board Colony, Taoru Road Nuh, Distt.Mewat Haryana - 122 107.",
    contact: "+91-1267-271461,271179",
  },
  {
    id: 7,
    state: "Bihar",
    name: "Bihar State Minorities Financial Corporation",
    address: "Haj Bhawan, 1st Floor, 34 Harding Road, Ali Imam Path PATNA - 800 001 BIHAR",
    contact: "+91-612-2204975, 2215994",
  },
  {
    id: 8,
    state: "Chandigarh",
    name:
      "Chandigarh Scheduled Caste, Backward Classes & Minorities Financial & Development Corporation",
    address:
      "Additional Town Hall Building, 3rd Floor Sector 17-C. CHANDIGARH-160017 (Union Territory of Chandigarh)",
    contact: "+91-172-2700372",
  },
  {
    id: 9,
    state: "Jharkhand",
    name: "Jharkhand State Minorities Finance & Development Corporation",
    address: "Ist Floor, Kalyan Complex, Balihar Road, Moradabadi Ranchi - 834 008 JHARKHAND",
    contact: "+91-651-2552055",
  },
  {
    id: 10,
    state: "Jammu & Kashmir",
    name: "J&K SCs/STs & BCs Development Corporation (Nov. to April)",
    address: "Lower Muthi, Opposite JDA,Flats Jammu, J&K 181205 (Union Territory of Jammu & Kashmir)",
    contact: "+91-191-2433229, 2451762,2452009",
  },
  {
    id: 11,
    state: "Jammu & Kashmir",
    name: "J&K Entrepreneurship Development Institute (JKEDI) (May to October)",
    address:
      "Sempora, Pampore Pantha Chowk, Srinagar - 191 101 (Union Territory of Jammu & Kashmir)",
    contact: "+91-1933-224364/65/62/66/67,224371",
  },
  {
    id: 12,
    state: "Jammu & Kashmir",
    name: "J&K Entrepreneurship Development Institute (JKEDI) (Nov. to April)",
    address: "Industrial State, Bari Brahmna Jammu - 181 201 (Union Territory of Jammu & Kashmir)",
    contact: "+91-1923-222455, 222412",
  },
  {
    id: 13,
    state: "Jammu & Kashmir",
    name: "Jammu & Kashmir and Ladakh Finance Corporation (May to oct)",
    address: "SFC House, Durganag, Srinagar- 190001 (Union Territory of Jammu & Kashmir)",
    contact: "+91-194-2500716, 2500606,2500592,2501734",
  },
  {
    id: 14,
    state: "Sikkim",
    name: "Sikkim SC/ST and other Backward Classes Development Corporation Ltd.",
    address: "Sonam Ishering Marg (Kazi Road), Gangtok - 737 101 (SIKKIM)",
    contact: "",
  },
  {
    id: 15,
    state: "Chhattisgarh",
    name: "Chhatisgarh State Antyavasai Sahakari Vitta Evum Vikas Nigam",
    address:
      "Sector-24, 2nd Tribal Research and Training Institute, Nawa Raipur, Atal Nagar, CHHATISGARH-492109",
    contact: "+91-771-2972731",
  },
  {
    id: 16,
    state: "Jammu & Kashmir",
    name: "J&K SCs/STs & BCs Development Corporation (May to October)",
    address:
      "Near Red Cross Office, Exchange Road, Srinagar- 190 001 (Union Territory of Jammu & Kashmir)",
    contact: "+91-194-2481988",
  },
  {
    id: 17,
    state: "Jammu & Kashmir",
    name: "Jammu & Kashmir and Ladakh Finance Corporation (Nov. to April)",
    address:
      "Sehkari Bhawan Rail Head, Complex, Jammu- 180012 (Union Territory of Jammu & Kashmir)",
    contact: "+91-191-2470772,2476465,2475581",
  },
  {
    id: 18,
    state: "Kerala",
    name: "Kerala State Backward Classes Development Corporation",
    address:
      "TC No.27/588(7) & (8) SENTINEL 2nd Floor, Pattoor, Vanchiyoor P.O. THIRUVANTHAPURAM - 695 035 KERALA",
    contact: "+91-471-2577550,2577539,2577540",
  },
  {
    id: 19,
    state: "Kerala",
    name: "Kerala State Women's Development Corpn.",
    address:
      "T.C.24/3279, Basanth, Opposite Manmohan Bunglow, Kowdiar P.O. THIRUVANTHAPURAM - 695 003 KERALA",
    contact: "+91-471-2727668",
  },
  {
    id: 20,
    state: "Kerala",
    name: "Kerala State Cooperative Federation for Fisheries Developmen",
    address: "Kamaleswaran, Manacaud P.O. THIRUVANTHAPURAM - 695 009. KERALA",
    contact: "+91-471-2457172,2457756,2458606",
  },
  {
    id: 21,
    state: "Maharashtra",
    name: "Maulana Azad Alpsankhyak Aarthik Vikas Nigam",
    address:
      "DDA Building, 2nd Floor, Old Custom House Shahid Bhagat Singh Marg, MUMBAI - 400 023 MAHARASHTRA",
    contact: "+91-22-22657982,22672293",
  },
  {
    id: 22,
    state: "Madhya Pradesh",
    name: "M.P. Backward Classes & Minorities Finance and Development Corporation",
    address:
      "Rajiv Gandhi Bhawan, Parisar-2, 1st Floor 35, Shyamala Hills, BHOPAL - 462 002 Madhya Pradesh",
    contact: "+91-755-2660209",
  },
  {
    id: 23,
    state: "Nagaland",
    name: "Nagaland Industrial Development Corpn.",
    address: "IDC House, P.B. No.5 Dimapur - 797 112 NAGALAND",
    contact: "+91-3862-230571-74",
  },
  {
    id: 24,
    state: "Delhi",
    name: "Delhi SC/ST/OBC Minorities & Handicapped Financial & Dev. Corporation",
    address: "Ambedkar Bhawan, Sector - 16, Rohini DELHI - 110 085 (Union Territory of Delhi)",
    contact: "+91-11-27572692, 27570627",
  },
  {
    id: 25,
    state: "Nagaland",
    name: "Nagaland Handloom & Handicrafts Development Corporation",
    address: "P.B.No.31, Half Nagarajan, Dimapur, NAGALAND - 797 112",
    contact: "+91-3862-224591",
  },
  {
    id: 26,
    state: "Nagaland",
    name: "Nagaland State Social Welfare Board",
    address: "New Secretariat Complex, Kohima - 797 001, Nagaland",
    contact: "+91-370-2270310",
  },
  {
    id: 27,
    state: "Odisha",
    name: "Odisha Backward Classes Finance Development Cooperative Corporation",
    address: "Q.No.A/6, Unit - 5, Near Rajiv Bhawan BHUBANESWAR - 751 001 ODISHA",
    contact: "+91-674-2391061",
  },
  {
    id: 28,
    state: "Punjab",
    name: "Punjab State Backward Classes Land Development & Finance Corporation",
    address: "SCO No.60-61, Sector 17-A CHANDIGARH 160 017",
    contact: "+91-172-2709261",
  },
  {
    id: 29,
    state: "Puducherry",
    name: "Puducherry Backward Classes and Minorities Development Corn",
    address: "No.1, VIII Cross, Anna Nagar, Nellithope, PUDUCHERRY - 605 005",
    contact: "+91-413-2205859",
  },
  {
    id: 30,
    state: "Rajasthan",
    name: "Rajasthan Minorities Finance & Development Cooperative Corporation",
    address:
      "Dr. S. Radhakrishnan Shiksha Shankul Parishar, Madarsa Board Building 3rd Floor JLN Marg Jaipur JAIPUR-302019 (RAJASTHAN)",
    contact: "+91-141-2700201",
  },
  {
    id: 31,
    state: "Tamil Nadu",
    name: "Tamil Nadu Minorities Economic Development Corporation",
    address: "Khalas Mahal, Heritage Building Ist Floor, Chepauk, CHENNAI - 600 005 (TAMIL NADU)",
    contact: "+91-44-28514846",
  },
  {
    id: 32,
    state: "Tripura",
    name: "Tripura Minorities Co-operative Development Corporation",
    address: "P.O. Lake Chowmuhani, Agartala WEST TRIPURA - 799 001 (TRIPURA)",
    contact: "+91-381-2300083, 2328232, 2326512",
  },
  {
    id: 33,
    state: "Uttar Pradesh",
    name: "U.P. Minorities Financial Development Corpn.",
    address: "746, 7th Floor, Jawahar Bhawan Ashok Marg, LUCKNOW - 226 001 UTTAR PRADESH",
    contact: "+91-522-2286158, 2286854, 2287213",
  },
  {
    id: 34,
    state: "Gujarat",
    name: "Gujarat Minorities Finance and Development Corporation",
    address:
      "Ground Floor Block No.11, Dr. Jivraj Mehta Bhawan GANDHINAGAR - 382 010 GUJARAT",
    contact: "+91-79-23254583,23253757,23253375",
  },
  {
    id: 35,
    state: "Mizoram",
    name: "Zoram Industrial Development Corporation",
    address: "New Secretariat Building, New Capital Complex Rd, Khatla, Aizawl, P. Box - 125 Mizoram - 796 001",
    contact: "+91-389-2310190,2333217",
  },
  {
    id: 36,
    state: "Manipur",
    name: "Manipur Minorities & Other Backward Classes Economic Development Society",
    address: "Old High Court Complex, North AOC, Imphal, Manipur - 795 001",
    contact: "+91-385-2452481",
  },
  {
    id: 37,
    state: "Uttarakhand",
    name: "Uttrakhand Alpsankhyak Kalyan Tatha Wakf Vikas Nigam",
    address:
      "Alpsankhyak Kalyan Bhawan, Shahid Bhagat Singh Colony, Adhoiwala, DEHRADUN (UTTRAKHAND)-248001",
    contact: "+91-135-2788723",
  },
  {
    id: 38,
    state: "Himachal Pradesh",
    name: "H.P. Minorities Finance and Development Corporation",
    address: "SDA Complex Block No.38, First Floor, Kasumpti SHIMLA - 171 009 HIMACHAL PRADESH",
    contact: "+91-177-2622164",
  },
  {
    id: 39,
    state: "Jammu & Kashmir",
    name: "J&K Women's Development Corporation (May to October)",
    address: "SDA Colony, Bemina, SRINAGAR- 190018 (Union Territory of Jammu & Kashmir)",
    contact: "+91-194-2506684-85",
  },
  {
    id: 40,
    state: "Jammu & Kashmir",
    name: "J&K Women's Development Corporation (Nov. to April)",
    address:
      "Hall No.6-B, 2nd Floor, Auqaf Complex, Gandhi Nagar Jammu (J&K)-180003 (Union Territory of Jammu & Kashmir)",
    contact: "+91-191-2430321, 2439370",
  },
  {
    id: 41,
    state: "Kerala",
    name: "Kerala State Minorities Development Finance Corporation",
    address: "1/1170 A Ground Floor, KURDFC Building, Chakkorathkulam, West Hill P.O., Calicut - 673 005 KERALA",
    contact: "+91-495-2369366",
  },
  {
    id: 42,
    state: "Karnataka",
    name: "Karnataka Minorities Development Corporation",
    address: "12th Floor, Main Tower Dr. B.R. Ambedkar Veedi BANGALORE - 560 001 KARNATAKA",
    contact: "+91-80-22861226,22864782",
  },
  {
    id: 43,
    state: "Mizoram",
    name: "Mizoram Cooperative Apex Bank",
    address: "Tuikual South Near Aizawl Tennis Court Aizawl - 796 001 MIZORAM",
    contact: "+91-389-2312307,2322744,2327514,2323045,2327514",
  },
  {
    id: 44,
    state: "West Bengal",
    name: "West Bengal Minorities Development and Finance Corporation",
    address: "AMBER, DD-27/E, Sector-1, Salt Lake City KOLKATA - 700 064. WEST BENGAL",
    contact: "+91-33-23219619,23342893 23344004, 23347469 23212995",
  },
  {
    id: 45,
    state: "Ladakh",
    name: "Sindhu Infrastructure Development Corporation Limited (SIDCO)",
    address: "Sidco Complex. Industrial Estate, Leh, Ladakh 194101",
    contact: "",
  },
  {
    id: 46,
    state: "Meghalaya",
    name: "Meghalaya Industrial Development Corporation Ltd.",
    address: "KISMAT Upland Road, Laitumkhrah, Shillong - 793003",
    contact: "0364-2223458, 2507414",
  },
  {
    id: 47,
    state: "Maharashtra",
    name: "Jain Minority Dev. Finance Corporation",
    address:
      "3rd Floor, Malhotra House, Near Chhatrapati Shivaji Maharaj Terminus, Opposite General Post Office, Mumbai, Maharashtra",
    contact: "",
  },
];

export default scaPartnersData;
